<template>
  <section class="mobile-header-root">
    <subscribe-mobile />
    <el-row
      :gutter="20"
      type="flex"
      align="middle"
      justify="space-between"
      class="select-root"
    >
      <el-col>
        <search-input
          :value="loadPoint"
          :is-prefix="false"
          placeholder="Поиск по месту погрузки"
          width="100%"
          custom-class="unloading-filter-search"
          @clear="onClear"
          @input="onInput"
          @search="$emit('fetch')"
        />
      </el-col>
      <el-col>
        <el-select
          v-model="selectFilter"
          class="select-style"
          multiple
          collapse-tags
          placeholder="Выберите место выгрузки"
        >
          <el-option
            v-for="item in listFilter"
            :key="item.value"
            class="option-style"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row />
    <el-row
      :gutter="24"
      type="flex"
      align="middle"
      class="bM_row wrapNotTransparent"
    >
      <el-col :span="24">
        <div class="df fw-wrap ai-c jc-sb">
          <el-radio-group
            v-model="type_code"
            class="radio-group-filter mb-15"
            fill="#67C23A"
            size="large"
          >
            <el-radio label="" border>Все</el-radio>
            <el-radio
              v-for="type in typeCodesFilters"
              :key="type.label"
              :label="type.label"
              border
            >
              {{ type.title }}
            </el-radio>
          </el-radio-group>
          <el-col class="w-auto mb-15 p-0">
            <el-button
              class="btn-map"
              type="success"
              plain
              @click="toggleButton()"
            >
              {{ getTypeView ? 'Показать на карте' : 'Показать списком' }}
            </el-button>
          </el-col>
          <el-col v-if="getBidIdLanding" class="w-auto mb-15 pr-0">
            <el-button
              type="danger"
              size="small"
              class="mobile-header-root__clear-btn"
              @click="handleClearBidIdLanding"
            >
              Очистить
            </el-button>
          </el-col>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { typeCodesFilters } from '@/datas/consts'
import SearchInput from '@/components/Shared/SearchInput'
import SubscribeMobile from '@/components/Mobile/SubscribeMobile'

export default {
  name: 'UnloadingFilterBids',
  components: { SubscribeMobile, SearchInput },
  props: {
    loadPoint: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      listFilter: [],
      defaultName: 'Показать на карте',
      typeCodesFilters,
    }
  },
  computed: {
    ...mapGetters({
      getTypeCode: 'bids/getTypeCode',
      getTypeView: 'bids/getTypeView',
      bids: 'bids/getBids',
      getUnloadPointKladrId: 'bids/getUnloadPointKladrId',
      getBidsKladrs: 'bids/getBidsKladrs',
      getBidIdLanding: 'bids/getBidIdLanding',
    }),
    type_code: {
      get() {
        return this.getTypeCode
      },
      set(value) {
        this.updateTypeCode(value)
      },
    },
    type_view: {
      get() {
        return this.getTypeView
      },
      set() {
        this.updateTypeView()
      },
    },
    selectFilter: {
      get() {
        return this.getUnloadPointKladrId
      },
      set(val) {
        this.updateUnloadPointKladrId(val)
      },
    },
  },
  watch: {
    getBidsKladrs: {
      immediate: true,
      handler(items) {
        this.listFilter = []
        items?.map(item => {
          this.listFilter.push({
            value: item.kladr,
            label: item.name,
          })
        })
      },
    },
    type_view(newValue) {
      this.defaultName = newValue ? 'Показать на карте' : 'Показать списком'
    },
  },
  methods: {
    ...mapMutations('bids', [
      'updateTypeView',
      'updateUnloadPointKladrId',
      'updateTypeCode',
    ]),
    toggleButton() {
      this.updateTypeView()
    },
    handleClearBidIdLanding() {
      this.$store.commit('bids/setBidIdLanding', null)
      this.onClear()
    },
    onInput(val) {
      this.$emit('input', val)
    },
    onClear() {
      this.$emit('input', '')
      this.$emit('fetch')
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"

.mobile-header-root
  position: fixed
  top: 0
  left: 0
  right: 0
  z-index: 1999
  .select-root
    padding: 8px 12px 10px 12px
    background: #FFFFFF
    font-weight: 400
    @include to(400px)
      flex-wrap: wrap
    .el-col
      @include to(400px)
        margin-bottom: 5px
    .unloading-filter-search
      input
        height: 26px
        font-size: 12px
      .el-input__icon
        line-height: 28px
    .option-style
      font-family: Rubik, sans-serif
      font-style: normal
      font-weight: 300
      font-size: 12px
      line-height: 17px
      color: #626262
      padding: 0
    .hover
      font-size: 12px
      line-height: 17px
      color: red!important
    .select-style
      width: 100%
      padding-right: 12px
      .el-input
        font-family: Rubik, sans-serif
        font-style: normal
        font-weight: 300
        font-size: 12px
        line-height: 17px
        color: #626262
        padding: 0
      .el-input__inner
        color: #626262
        background: #F5F5F5
        border: 1px solid #DADADA
        box-sizing: border-box
        border-radius: 3px
        height: 26px
        padding: 4px
      .el-input--suffix .el-input__inner
        height: 26px
      .el-input__icon
        height: 116%
        display: none
      .el-select__tags
        max-width: 180px!important
        flex-wrap: nowrap

      .el-tag
        background: white!important
        height: 18px
        font-weight: 300
        font-size: 10px
        line-height: 18px
        color: black
      .el-tag--small
        padding: 0 4px

  .btn-map
    margin-top: -1px
    width: 100%
    padding: 5px 12px!important
    margin-left: 0
    background: #FFFFFF!important
    border: 1px solid #34C800
    box-sizing: border-box
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25)
    border-radius: 5px
    color: #34C800!important
  .mb-15
    margin-bottom: 15px
  .pl-0
    padding-left: 0 !important
  .p-0
    padding: 0 !important
  .radio-group-filter
    .el-radio
      padding: 5px 12px!important
      background: #FFFFFF!important
      box-sizing: border-box
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25)
      border-radius: 5px
      font-weight: 400
      color: #2D2D2D
      height: 26px
      border: none
      margin-right: 0
      @include to(450px)
        padding: 5px 8px !important
    .is-checked
      background: #67C23A!important
      color: white!important
      .el-radio__label
        color: white!important
      font-weight: 500
      span
       padding-left: 0
      .el-radio__input
        display: none
    .el-radio__inner
      display: none
    span
      padding-left: 0
      .is-checked
        background: #67C23A!important
        color: white!important
  .wrapNotTransparent
    padding: 8px 12px 0 12px
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25)
    background: rgba(255,255,255,1)
    .el-radio.is-bordered+.el-radio.is-bordered
      margin-left: 0
    .el-radio.is-bordered
      margin-right: 10px

  &__clear-btn
    margin-left: auto
    padding: 7px 4px
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25)
    border-radius: 5px
    border: 1px solid inherit
    box-sizing: border-box
</style>
